module.exports = __webpack_public_path__ + "img/MT.3663a0e1.png";